import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'

import CurrencyClass from './../../../../../../../js/classes/Currency'
import CartClass from './../../../../../../../js/classes/Cart'
import ScrollClass from './../../../../../../../js/classes/Scroll'
import AppClass from './../../../../../../../js/classes/App'

const Summary = ({ cart, refetch, deliveryPrice, setLoading, iScrollUpdate }) => {
    const setPromocode = (promocode) => {
        CartClass.setCoupon(promocode, (err, res) => {
            if (err) {

            } else {
                refetch(() => {
                    iScrollUpdate()
                })

                const locationContainer = document.querySelector('.happy-order__delivery-select-location')

                if (locationContainer) {
                    AppClass.runCallback('select_location_change', {
                        ID : +locationContainer.getAttribute('data-id'),
                        NAME : locationContainer.textContent.trim(),
                    })
                }
            }
        })
    }

    const promocodeInput = useRef(null),
    handleSetPromocode = (e) => {
        e.preventDefault()

        const promocode = promocodeInput.current.value

        setPromocode(promocode)

        setLoading(true)

        return false
    },
    coupon = cart.coupons.length > 0 ? cart.coupons[0] : null

    useEffect(() => {
        AppClass.addCallback('set_small_cart_promocode', (promocode) => {
            if (promocode) {
                if (promocodeInput.current.value === '') {
                    promocodeInput.current.value = promocode
                    setPromocode(promocode)
                }
            } else {
                if (parseInt(promocodeInput.current.value) > 0) {
                    promocodeInput.current.value = ''
                    setPromocode('')
                }
            }
        })
    }, [])

    return <>
        <div className="happy-cart-small__summary">
            <div className="happy-cart-small__summary-node">
                <div className="happy-cart-small__summary-key">
                    Товаров на:
                </div>
                <div className="happy-cart-small__summary-value">
                    { cart.summary_format }
                    { (Math.abs(cart.discount_summary) > 0) ? <>
                        <br /><strike className="happy-cart-small__summary-strike">{ cart.summary_base_format }</strike>
                    </> : null }
                </div>
            </div>

            { Math.abs(cart.discount_summary) > 0 ?<div className="happy-cart-small__summary-node">
                <div className="happy-cart-small__summary-key">
                    Ваша скидка:
                </div>
                <div className="happy-cart-small__summary-value">
                    { cart.discount_summary_format }
                </div>
            </div> : null }

            { (deliveryPrice || deliveryPrice == null || deliveryPrice == false || deliveryPrice === 0) ? <div className="happy-cart-small__summary-node">
                <div className="happy-cart-small__summary-key">
                    Доставка:
                </div>
                <div className="happy-cart-small__summary-value">
                    { (deliveryPrice === 0) ?
                        <strong className="happy-cart-small__summary-delivery-free">Бесплатно</strong>
                    : (deliveryPrice === false) ?
                        <strong className="happy-cart-small__summary-delivery-manager">Уточняйте у менеджера</strong>
                    : deliveryPrice === null ? 
                        <strong className="happy-cart-small__summary-delivery-free">Идёт расчёт..</strong>
                    : CurrencyClass.format(deliveryPrice) }
                </div>
            </div> : null }
        </div>

        <div className="happy-cart-small__promocode">
            <div className="happy-cart-small__promocode-title">Промокод или штрихкод скидочной карты</div>
            
            <form
                action=""
                method="post"
                className="happy-cart-small__promocode-form"
                onSubmit={ handleSetPromocode }
            >
                <input
                    type="text"
                    className="input happy-cart-small__promocode-input"
                    ref={ promocodeInput } placeholder="Промокод"
                    defaultValue={ coupon }
                />

                <button className="button button_black happy-cart-small__promocode-submit">Применить</button>
            </form>
        </div>

        <div className="happy-cart-small__total" onClick={ () => ScrollClass.scrollTo('.happy-order__footer', 300) }>
            <div className="happy-cart-small__total-key">
                Итого: 
            </div>
            <div className="happy-cart-small__total-value" data-summary={ cart.summary + (deliveryPrice > 0 ? deliveryPrice : 0) }>
                { CurrencyClass.format(cart.summary + (deliveryPrice > 0 ? deliveryPrice : 0)) }
            </div>
        </div>
    </>
}

export default Summary